import React from 'react';
import { Link } from 'react-router-dom';
import AppStoreMobileSection from '../common/AppStoreMobileSection';

/**
 * Shared shell for Privacy Policy & Terms (public routes, no marketing Header).
 */
export default function LegalDocumentLayout({ title, lastUpdated, children }) {
  return (
    <div className="min-h-screen bg-white">
      <div className="bg-gradient-to-r from-blue-900 via-indigo-900 to-slate-900 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14">
          <Link
            to="/"
            className="inline-flex items-center text-sm text-blue-200 hover:text-white transition-colors mb-6"
          >
            <span className="mr-2" aria-hidden>
              ←
            </span>
            Back to home
          </Link>
          <h1 className="text-3xl md:text-4xl font-bold tracking-tight">{title}</h1>
          <p className="mt-3 text-sm text-blue-100/90">Last updated: {lastUpdated}</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14 text-gray-700 leading-relaxed text-base">
        {children}
      </div>

      <footer className="border-t border-gray-200 bg-gray-50 py-8">
        <div className="max-w-4xl mx-auto px-4 space-y-6">
          <AppStoreMobileSection
            align="center"
            titleClassName="text-sm font-semibold text-gray-700"
          />
          <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-gray-600">
            <Link to="/terms" className="hover:text-blue-600 font-medium">
              Terms of Service
            </Link>
            <span className="text-gray-300" aria-hidden>
              |
            </span>
            <Link to="/privacy" className="hover:text-blue-600 font-medium">
              Privacy Policy
            </Link>
            <span className="text-gray-300 hidden sm:inline" aria-hidden>
              |
            </span>
            <Link to="/" className="hover:text-blue-600">
              Home
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}

export function LegalSection({ id, title, children }) {
  return (
    <section id={id} className="mb-10 scroll-mt-24">
      <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">{title}</h2>
      <div className="space-y-4">{children}</div>
    </section>
  );
}
